import styled from 'styled-components'

export const SubscribeBottomCTA = styled.div<{
  $backgroundDesktop: string
  $backgroundMobile: string
}>`
  width: 100%;
  background: url(${({ $backgroundDesktop }) => $backgroundDesktop}) center / cover no-repeat;
  padding: 64px 16px;
  position: relative;
  z-index: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  box-sizing: border-box;

  h2 {
    text-align: center;
    margin-bottom: 32px;
  }

  p {
    text-align: center;
    color: #131d40;
    font-weight: 700;
  }

  > div {
    max-width: 650px;
    width: 100%;
    text-align: center;
  }

  ${({ theme, $backgroundMobile }) => theme.breakpoints.down('sm')} {
    background-image: url(${({ $backgroundMobile }) => $backgroundMobile});
  }
`
